<template>
  <f7-page>
    <div class="nf-card">
      <!-- Ilustración: círculo rojo con X centrada -->
      <div class="nf-illustration" aria-hidden="true">
        <svg class="nf-x" viewBox="0 0 160 160">
          <!-- Halo de fondo -->
          <circle cx="80" cy="80" r="55" fill="#FCE8E8" />
          <!-- Círculo rojo -->
          <circle cx="80" cy="80" r="24" fill="#A80D0B" />
          <!-- X blanca -->
          <path
            d="M70 70 L90 90 M90 70 L70 90"
            stroke="#FFFFFF"
            stroke-width="6"
            stroke-linecap="round"
          />
        </svg>
      </div>

      <!-- Mensaje principal -->
      <div class="nf-content">
        <h1 class="nf-title">
          {{ $t('notFound.title') }}
        </h1>
        <p class="nf-subtitle">
          {{ $t('notFound.message') }}
        </p>
      </div>

      <!-- Acciones -->
      <div class="nf-actions">
        <f7-button
          class="nf-btn nf-btn--outline"
          @click="onOpenSupportHandler"
        >
          {{ $t('notFound.support') }}
        </f7-button>
        <f7-button class="nf-btn nf-btn--primary" @click="goHome">
          {{ $t('notFound.backHome') }}
        </f7-button>
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NotFoundPage',
  computed: {
    currentPath() {
      try {
        return (
          this.$f7?.views?.main?.router?.currentRoute?.url ||
          this.$f7?.views?.main?.router?.currentRoute?.path ||
          window.location?.href ||
          '/'
        );
      } catch {
        return '/';
      }
    },
    ...mapGetters('user', ['getLanguage']),
  },
  methods: {
    // Vuelta a la pantalla anterior o al inicio
    goHome() {
      const router = this.$f7?.views?.main?.router;
      if (router?.history?.length > 1) router.back();
      else
        router?.navigate('/', {
          animate: true,
          transition: 'f7-fade',
        });
    },
    // Apertura de email de soporte (alineado con la barra superior)
    onOpenSupportHandler() {
      let mail = 'info@agqlabs.com';
      if (this.getLanguage === 'es') {
        mail = 'atencioncliente.esp@agqlabs.com';
      } else if (this.getLanguage === 'en') {
        mail = 'info@agqlabs.com';
      } else if (this.getLanguage === 'it') {
        mail = 'italia@agqlabs.com';
      } else if (this.getLanguage === 'pt') {
        mail = 'infoportugal@agqlabs.com';
      }
      const subject = encodeURIComponent(
        'Error 404 - Página no encontrada'
      );
      const body = encodeURIComponent(
        `Hola,\n\nHe encontrado un error 404 en la ruta:\n${this.currentPath}\n\n¿Podéis ayudarme?\n\nGracias.`
      );
      window.open(
        `mailto:${mail}?subject=${subject}&body=${body}`,
        '_blank'
      );
    },
  },
};
</script>

<style scoped>
.nf-card {
  width: auto;
  margin: auto;
  padding: 24px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 4px 0 rgba(87, 84, 95, 0.30);
  text-align: center;
  gap: 32px;
}

/* Ilustración centrada */
.nf-illustration {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 8px auto 10px;
}
.nf-x {
  display: block;
  width: 150px;
  height: 150px;
}

/* Tipografías */
.nf-title {
  margin: 4px 0 8px;
  font-weight: 700;
  font-size: 22px;
  color: #101828;
}
.nf-subtitle {
  margin: 0 auto 40px;
  max-width: 625px;
  color: #475467;
  font-size: 16px;
  line-height: 1.5;
}

/* Contenedor de botones */
.nf-actions {
  display: flex;
  gap: 24px;
  justify-content: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

/* Botones */
.nf-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  border: 1px solid var(--Primary-Blue-70, #00346a);
  background: var(--Basic-White, #fff);
  color: var(--Primary-Blue-70, #00346a);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
}

/* Outline (estado normal) */
.nf-btn--outline {
  background: #fff;
  color: #00346a;
  border: 1px solid #00346a;
}

/* Outline (hover/focus) */
.nf-btn--outline:hover,
.nf-btn--outline:focus {
  background: var(--Primary-Blue-10, #EBF2FA) !important;
  color: #00346a;
  border-color: #00346a;
  box-shadow: 0 1px 4px 0 rgba(87, 84, 95, 0.3),
    0 1px 4px 0 rgba(87, 84, 95, 0.15);
}

/* Outline (active) */
.nf-btn--outline:active {
  transform: translateY(1px);
}

/* Primary (estado normal) */
.nf-btn--primary {
  background: #00346a;
  color: #fff;
  border: 1px solid #00346a;
}

/* Primary (hover/focus) */
.nf-btn--primary:hover,
.nf-btn--primary:focus {
  background: #04509f !important;
  border-color: #04509f !important;
  box-shadow: 0 1px 4px 0 rgba(87, 84, 95, 0.3),
    0 1px 4px 0 rgba(87, 84, 95, 0.15);
}

/* Primary (active) */
.nf-btn--primary:active {
  transform: translateY(1px);
}

/* Compatibilidad con <span> interno de Framework7 */
.nf-btn span {
  line-height: 1;
}

/* Responsive */
@media (max-width: 640px) {
  .nf-card {
    padding: 24px 18px;
    margin: 32px auto;
  }
  .nf-x {
    width: 136px;
    height: 136px;
  }
  .nf-title {
    font-size: 22px;
  }
  .nf-subtitle {
    font-size: 15px;
  }
  .nf-btn {
    min-width: 200px;
    height: 42px;
    font-size: 14px;
  }
}
</style>
